<template>
    <div>
        <b-row class="pb-2">
            <b-col>
                <app-detalhe titulo="Tipo Contrato" :size="size">
                    <strong>{{
                        contrato.dadosContratoRM
                            ? contrato.dadosContratoRM.tipoContratoRMDto
                                  .descricao
                            : ''
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Status Contrato" :size="size">
                    <strong>ATIVO</strong>
                </app-detalhe>
                <app-detalhe titulo="Natureza Contrato" :size="size">
                    <strong>COMPRA</strong>
                </app-detalhe>
                <app-detalhe titulo="Tipo Faturamento" :size="size">
                    <strong>{{
                        contrato.dadosContratoRM
                            ? contrato.dadosContratoRM
                                  .tipoProdutoFaturamentoRmDto.descricao
                            : ''
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Condição de pagamento" :size="size">
                    <strong>À VISTA</strong>
                </app-detalhe>
                <app-detalhe titulo="Classif. Natureza" :size="size">
                    <strong>{{
                        contrato.dadosContratoRM
                            ? contrato.dadosContratoRM.tipoNaturezaDto.descricao
                            : ''
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Gestor do Contrato" :size="size">
                    <strong>{{
                        contrato.dadosContratoRM
                            ? contrato.dadosContratoRM.gestorContrato.nome
                            : ''
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Gerente do Gestor" :size="size">
                    <strong>{{
                        contrato.dadosContratoRM
                            ? contrato.dadosContratoRM.gerenteGestor.nome
                            : ''
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Representante" :size="size">
                    <strong>{{
                        contrato.dadosContratoRM
                            ? contrato.dadosContratoRM.representanteRMDto.nome
                            : ''
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Tipo do rateio" :size="size">
                    <strong>Rateio definido no contrato</strong>
                </app-detalhe>
                <app-detalhe titulo="Tipo do Movimento" :size="size">
                    <strong>
                        {{
                            contrato.dadosContratoRM
                                ? contrato.dadosContratoRM.tipoMovimento
                                : ''
                        }}
                    </strong>
                </app-detalhe>
                <app-detalhe titulo="Tipos de movimentos adicionais" :size="size"
                    v-if="contrato.tiposMovimentosAdicionais"
                >
                    <strong>
                        {{contrato.tiposMovimentosAdicionais}}
                    </strong>
                </app-detalhe>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            size: '200'
        }
    }
}
</script>
